import React, { useEffect, useState } from "react";
import config from "../config";
import Loading from "react-loader-spinner";
import { useLang } from "../helpers/language";
import ParallaxHeader from "../components/parallax-header/ParallaxHeader";
import NewsSlider from "../components/news-slider/NewsSlider";
import BottleTypes from "../components/bottle-types/BottleTypes";
import AboutCraftBeer from "../components/about-craft-beer/AboutCraftBeer";
import Locations from "../components/locations/Locations";
import AboutBlock from "../components/about-block/AboutBlock";

export default function Home() {
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);

  useEffect(() => {
    (async () => {
      setBusy(false);
    })();
    // eslint-disable-next-line
  }, [isBusy]);

  if (isBusy) return <Loading type="Oval" color="#FFBE03" className="loader" />;
  else
    return (
      <>
        <ParallaxHeader />
        <NewsSlider />
        <BottleTypes />
        <AboutCraftBeer />
        <Locations />
        <AboutBlock
              title={config.aboutUsBlock.home.title[lang]}
              subTitle={''}
              content={''}
              buttonText={config.aboutUsBlock.home.button[lang]}
              as={'/about-us'}
              href={'/about-us'}
          />
      </>
    );
}
